import { applyMiddleware, createStore, compose } from "redux";
import { combineReducers } from "redux";
import thunk from "redux-thunk";
import { reducer as reduxFormReducer } from "redux-form";
import { loadTranslations, setLocale, syncTranslationWithStore, i18nReducer } from 'react-redux-i18n';
import brandsReducer from "./brands/brandsReducer";
import productsReducer from "./products/productsReducer";
import ordersReducer from "./orders/ordersReducer";
import projectReducer from "./project/projectReducer";
import titlesReducer from "./query/queryReducer";
import bannersReducer from "./banners/bannersReducer";
import customerReducer from "./register/customerReducer";
import addressReducer from "./register/addressReducer";
import loginReducer from "./login/loginReducer";
import alertBoxReducer from "./alertbox/alertboxReducer";
import { langTH } from "../locale/th";
import { langEN } from "../locale/en";

const translationsObject = {
  th: langTH,
  en: langEN
}

const reducers = combineReducers({
  products: productsReducer,
  brands: brandsReducer,
  orders: ordersReducer,
  project: projectReducer,
  titles: titlesReducer,
  banners: bannersReducer,
  customer: customerReducer,
  address: addressReducer,
  form: reduxFormReducer,
  login: loginReducer,
  alertbox: alertBoxReducer,
  i18n: i18nReducer
});

const initialState = {};

const middleware = [thunk];

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const store = createStore(
  reducers,
  initialState,
  compose(
    applyMiddleware(...middleware),
    enhancer
  )
);

syncTranslationWithStore(store);
store.dispatch(loadTranslations(translationsObject));
store.dispatch(setLocale('th'));

export default store;
